// Angular imports
import { Component, OnInit, OnDestroy } from '@angular/core';

// Import rxjs sub
import { Subject, Subscription, combineLatest, takeUntil } from 'rxjs';

// Import services

// Import types
import { CalculationLineApi } from '../types/calculation';
import { Project } from '../types/project';
import { Store } from '@ngrx/store';
import { AppState } from '../state-management/app-state';
import { selectAggregation, selectAggregationOnLoad, selectCurrentSelection, selectHourRates, selectLines, selectWarnings } from '../state-management/calculation-selectors';
import { isCalculationLineApi } from '../state-management/calculation-state';

@Component({
    selector: 'footer-bar',
    templateUrl: './footer-bar.component.html',
    styleUrls: ['./footer-bar.component.scss'],
    standalone: false
})
export class FooterBarComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();

    public _project: Project;

    public _totalOnOpen: number;
    public _currentTotal: number;
    public _currentHourlyRate?: number;
    public _numHours: number;
    public _numLines: number;
    public _numWarnings: number;
    public _syncing: boolean = false;

    private subscriptions: Subscription[] = [];

    constructor(
        private store: Store<AppState>
    ) {
        this.store.select(selectAggregation)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((aggregation) => {
                this._currentTotal = aggregation?.all.gross;

                this._numHours = aggregation?.hours.hours;
            });

        this.store.select(selectLines)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(lines => {
                this._numLines = lines.length;
            })

        this.store.select(selectWarnings)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(warnings => {
                this._numWarnings = warnings.length;
            })

        this.store.select(selectAggregationOnLoad)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((aggregation) => {
                this._totalOnOpen = aggregation?.all.gross;
            });

        combineLatest([
            this.store.select(selectCurrentSelection),
            this.store.select(selectHourRates)
        ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(([selection, rates]) => {
                const firstSelected = selection?.selectedLines?.[0];

                if(firstSelected && isCalculationLineApi(firstSelected)){
                    this._currentHourlyRate = firstSelected.isTextLine ? undefined : rates.find(f => f.id === (firstSelected as CalculationLineApi).rate)?.value;
                }
            })

    }

    public ngOnInit(): void {
    }

    public ngOnDestroy(): void {
        // Unsubscribe
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
